<template>
  <div id="page">
    <NavBar />
    <Errors
      v-if="errors"
      :errors="errors"
    />
    <div
      v-if="showData"
      class="header_height"
    >
      <nav
        class="secondary_nav header_height"
        style="position: fixed; z-index: 10;"
      >
        <div class="col-lg-12">
          <ul class="clearfix">
            <li>
              <a :href="`/${this.$store.state.main.lang}/search`">
                <i
                  class="arrow_left"
                  style="vertical-align: middle"
                />
                {{ $t('lang.bookings.back_to_search') }}
              </a>
            </li>

            <li v-if="booking.booking_status != 'closed'">
              <b-link
                v-scroll-to="{el: '#schedule', offset: -140}"
                href="#"
                class="active"
              >
                {{ $t('lang.stores.schedule_nav') }}
              </b-link>
            </li>

            <li>
              <b-link
                v-scroll-to="{el: '#location', offset: -140}"
                href="#"
                class="active"
              >
                {{ $t('lang.stores.location') }}
              </b-link>
            </li>

            <li v-if="showChat">
              <b-link
                v-scroll-to="{el: '#chat', offset: -140}"
                href="#"
                class="active"
              >
                {{ $t('lang.stores.chat') }}
              </b-link>
            </li>
          </ul>
        </div>
      </nav>
    </div>

    <div
      v-if="showData"
      class="col-lg-12 margin_30"
    >
      <Success
        v-if="success_message"
        :success-message="success_message"
      />

      <!--  *** UP & FIRST - LEAVE REVIEW MOBILE -->
      <LeaveReview
        v-if="booking.booking_status === 'closed' && !booking.review && isMobile"
        class="d-block d-md-none"
        :booking="booking"
      />

      <div
        v-if="booking.store.is_locker && booking.booking_status === 'pending'"
        class="alert alert-warning"
      >
        <p class="m-0">
          <i class="fas fa-lock" />
          <span v-html="$t('lang.lockers.store_description')" />
        </p>
      </div>

      <!--  *** SIDEBAR - BOOK INFO  -->
      <div
        v-if="showData"
        id="div_sidebar"
        class="col-lg-5 col-md-6 col-sm-12 fixed_booking_aside mt-2"
      >
        <h5 class="d-inline">
          {{ $t('lang.bookings.booking_details') +' #'+ booking.id }}
        </h5>
        <aside
          id="sidebar"
          class="mt-2"
        >
          <div class="box_detail booking">
            <BookingInfo
              :booking="booking"
              :allow-modification="allowModification"
              :origin="bookingInfoOrigin"
              @updateSchedules="updateBookingSchedules"
            />

            <!--    ASK FOR INSURANCE DATA    -->
            <h6
              v-if="askForInsuranceData"
              class="details_items"
            >
              &nbsp;🔒&nbsp;<span class="small">{{ $t('lang.user.insurance.title') }}</span>

              <b-link
                class="ml-2"
                href="#"
                @click="$bvModal.show('insurance-data-modal');"
              >
                <small> {{ $t('lang.user.insurance.link') }}</small>
              </b-link>
            </h6>

            <FreeTourIncluded
              :booking-id="booking.id"
              :booking-status="booking.booking_status"
              :selected-activity="selectedFreeTour"
              :selected-activity-details="selectedFreeTourDetails"
            />

            <!--    EXTRA DATA REQUIRED BY SPECIFIC PARTNERS/LOCKERS    -->
            <BookingExtraData
              v-if="showExtraData && !showPayment"
              :user="booking.user"
              :required-data="booking.required_data"
              @extraDataCompleted="showPayment=true"
            />

            <!--    PAYMENT    -->
            <div v-if="showPayment">
              <Payment
                :booking="booking"
                style="padding: 10px 0 0 0"
              />

              <div
                class="mb-3"
                style="text-align: justify;  text-justify: inter-word;"
              >
                <p
                  v-if="booking.booking_status === 'pending'"
                  class="small mb-0"
                >
                  <em v-if="isLockerCancelNotAllowed"><b>{{ $t('lang.bookings.cancel_warning_handover') }}</b></em>
                  <em v-else>{{ $t('lang.bookings.cancel_warning') }}</em>
                </p>

                <p class="small mb-0">
                  <em v-if="this.booking.store.country === 'AR'">
                    {{ $t('lang.bookings.managed_by_cyg') }}
                  </em>
                  <em v-else>
                    {{ $t('lang.bookings.managed_by_llc') }}
                  </em>
                </p>
              </div>
            </div>

            <!--    TRANSFERS    -->
            <div v-if="booking.booking_status !== 'pending' && showTransfer">
              <b-link
                class="btn btn_1 btn_secondary mb-3 full-width"
                style="padding: 10px 30px; font-size: .875rem; font-weight: 500;"
                @click="openTransfer()"
              >
                <i class="fas fa-car pr-1" />
                {{ $t('lang.bookings.transfer_button') }}
              </b-link>
            </div>

            <div
              v-if="showClaim"
              class="clearfix"
            >
              <div class="float-right mt-1">
                <button
                  class="btn btn-link link-light nopadding"
                  data-toggle="modal"
                  data-target="#claimModal"
                  style="font-size: 14px;"
                >
                  {{ $t('lang.bookings.new_claim') }}
                </button>
              </div>
            </div>

            <div class="clearfix">
              <div
                v-if="booking.booking_status === 'pending' && !showProcessingDiscount"
                class="float-right mt-1"
              >
                <button
                  class="btn btn-link link-light nopadding"
                  data-toggle="modal"
                  data-target="#discountCouponModal"
                  style="font-size: 14px;"
                >
                  {{ $t('lang.bookings.discount_coupon') }}
                </button>
              </div>

              <div
                v-if="showProcessingDiscount"
                class="float-right mt-1"
              >
                <b>{{ $t('lang.bookings.processing_discount') }}</b>
                <i
                  class="icon-spin6 animate-spin"
                  style="font-size: 130%"
                />
              </div>
            </div>

            <div
              v-if="allowCancellingBooking"
              class="clearfix"
            >
              <div class="float-right mt-1">
                <button
                  v-if="booking.payment_provider !== 'stripe'
                    && booking.payment_provider !== 'mp'
                    && booking.payment_provider !== 'pix'
                    && booking.payment_provider !== 'mp_api'"
                  class="btn btn-link link-light nopadding"
                  style="font-size: 14px;"
                  @click="showCannotCancelModal"
                >
                  {{ $t('lang.bookings.cancel_button') }}
                </button>

                <button
                  v-else
                  class="btn btn-link link-light nopadding"
                  style="font-size: 14px;"
                  @click="showCancelBookingModal"
                >
                  {{ $t('lang.bookings.cancel_button') }}
                </button>
              </div>
            </div>
          </div>
        </aside>
      </div>

      <!--  *** MAIN CONTENT  -->
      <div
        v-if="showData"
        class="col-lg-6 col-md-6 col-sm-12 booking-description"
      >
        <!--  LEAVE REVIEW NOT MOBILE -->
        <LeaveReview
          v-if="booking.booking_status === 'closed' && !booking.review && !isMobile"
          class="d-none d-md-block"
          :booking="booking"
        />
        <FreeTourCarousel
          v-if="booking.booking_status!== 'pending'"
          :city-id="booking.store.city_id"
          :booking-id="booking.id"
          :transfer-url="transferUrl"
        />

        <StoreInfo
          :booking="booking"
          :show-chat="showChat"
          :show-reviews="showReviews"
        />
      </div>
    </div>

    <div
      id="discountCouponModal"
      class="modal fade"
      tabindex="-1"
      role="dialog"
      aria-labelledby="discountCouponModal"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-centered"
        role="document"
      >
        <div class="modal-content">
          <div class="card card-alert text-dark bg-main-color o-hidden h-100">
            <div class="card-body">
              <h5>{{ $t('lang.bookings.insert_discount_coupon') }}</h5>
            </div>
            <div class="card-footer bg-white text-center">
              <input
                id="discount_code"
                v-model="discountCode"
                type="text"
                class="form-control"
                name="discount_code"
                style="text-transform: uppercase;"
                autocomplete="off"
                required
              >
              <button
                type="button"
                class="btn btn-outline-dark"
                data-dismiss="modal"
              >
                {{ $t('lang.forms.cancel') }}
              </button>
              <button
                type="submit"
                class="btn btn-outline-main-color"
                :disabled="discountCodeIsEmpty"
                data-dismiss="modal"
                @click="updateBookingDiscount"
              >
                {{ $t('lang.bookings.validate_discount_coupon') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <StartClaim
      v-if="showData"
      :booking-id="booking.id"
      @toHelpCenter="toHelpCenter"
    />

    <!-- Alert Modal -->
    <ModalAlert
      :modal-info="modalAlertInfo"
      @clickModal="clickModal"
    />

    <UserInsuranceData
      :user-data="userData"
      :store-country="storeCountry"
      :booking-id="bookingId"
      @dataLoaded="askForInsuranceData=false"
      @insuranceModalClosed="askForFreeTourData()"
    />

    <FooterComponent />
  </div>
</template>

<style scoped>
  td {
    padding: 0;
    border-top: none;
  }

  th {
    padding: 0;
  }
</style>

<script>
import moment from 'moment';
import BookingInfo from '@/components/Booking/BookingInfo';
import ModalAlert from '@/components/Alerts/ModalAlert';
import UserInsuranceData from '@/components/User/UserInsuranceData';
import StoreInfo from '@/components/Booking/StoreInfo';
import FreeTourCarousel from '@/components/Activity/FreeTourCarousel';
import { cities } from '@/data/cities';
import NavBar from '../components/NavBar/NavBar';
import Errors from '../components/Alerts/Errors';
import Success from '../components/Alerts/Success';
import Payment from '../components/Payments/Payment';
import StartClaim from '../components/Booking/StartClaim';
import LeaveReview from '../components/Booking/LeaveReview';
import FooterComponent from '../components/FooterComponent';

import { API, errorResponse } from '../api/api';
import FreeTourIncluded from '@/components/Activity/FreeTourIncluded.vue';
import BookingExtraData from '@/components/Booking/BookingExtraData.vue';
import { getTrackingIds } from '@/utils/tracking';

const BookingAPI = API.get('booking');
const ShippingAPI = API.get('shipping');
const ActivitiesAPI = API.get('activities');

export default {
  name: 'BookingDetails',

  components: {
    FreeTourIncluded,
    FreeTourCarousel,
    StoreInfo,
    UserInsuranceData,
    ModalAlert,
    NavBar,
    Success,
    Errors,
    Payment,
    StartClaim,
    LeaveReview,
    FooterComponent,
    BookingInfo,
    BookingExtraData,
  },

  data() {
    return {
      booking: {},
      booking_id: null,
      errors: {},
      success_message: null,
      listErrors: { results_error: [this.$t('lang.bookings.no_results')] },
      showData: false,
      showChat: false,
      showClaim: false,
      showReviews: false,
      discountCode: '',
      showProcessingDiscount: false,
      showPricesDetails: false,
      updateBookingData: {},
      allowModification: false,
      bookingInfoOrigin: 'details',
      modalAlertInfo: {},
      askForInsuranceData: false,
      storeCountry: '',
      bookingId: 0,
      userData: {},
      cityId: null,
      showTransfer: false,
      transferUrl: null,
      selectedFreeTour: null,
      selectedFreeTourDetails: null,
      lockers: [],
      lockersInitialized: false,
      isMobile: window.innerWidth < 768,
      showExtraData: false,
      showPayment: false,
    };
  },

  computed: {
    discountCodeIsEmpty() {
      return this.discountCode.trim() === null || this.discountCode.trim() === '';
    },

    isLockerCancelNotAllowed() {
      const cancelNotAllowedCompanyIds = process.env.VUE_APP_LOCKERS_NON_CANCELLABLE_COMPANY_ID || '';
      const companyIdArray = cancelNotAllowedCompanyIds.split(',').map((id) => parseInt(id.trim()));
      return companyIdArray.includes(this.booking.store.company_id);
    },

    allowCancellingBooking() {
      let allowCancelling = false;
      const bookingStatus = this.booking.booking_status;

      if (bookingStatus === 'confirmed') {
        const limitDate = moment(this.booking.start_date).add(1, 'days').format('YYYY-MM-DD');
        const limitHour = moment(this.booking.start_date).add(12, 'hours').format();
        const now = moment(new Date()).format();

        allowCancelling = true;
        if (limitDate < now && limitHour < now) {
          allowCancelling = false;
        }

        if (this.isLockerCancelNotAllowed) {
          const startDate = moment(this.booking.start_date).format('YYYY-MM-DD');
          if (startDate < now) {
            allowCancelling = false;
          }
        }
      }
      return allowCancelling;
    },

  },

  async beforeCreate() {
    if (this.$route.params.id) {
      this.booking_id = parseInt(this.$route.params.id, 10);

      try {
        const { data } = await BookingAPI.getBooking(this.booking_id);
        this.booking = data;
        this.showData = true;
        this.bookingStatus();

        if (data.booking_status === 'pending') {
          this.resetUpdateBookingData();
          this.allowModification = true;

          if (data.required_data != null && data.required_data.length > 0) {
            this.showExtraData = true;
            this.showPayment = false;
          } else {
            this.showPayment = true;
          }
        }

        this.checkInsuranceData();
      } catch (error) {
        this.errors = errorResponse(error);

        if (error.response.status === 401) {
          await this.$store.dispatch('setAuthToShow', 'login');
          this.$root.$emit('bv::show::modal', 'authModal');
          // GTAG Event
          dataLayer.push({
            event: 'open_auth_modal',
            source: 'booking',
          });
        }
      }
      window.scrollTo(0, 0);

      this.readUrl();
      if (this.booking.booking_status === 'pending') {
        this.showAlerts();
      }

      this.getCivitatisData();
    } else {
      this.$router.push('/bookings');
    }
  },

  methods: {
    readUrl() {
      const { query } = this.$route;
      const bookingPending = this.booking.booking_status === 'pending';
      if (query.payment) {
        if (query.payment === 'success') {
          this.success_message = this.$t('lang.bookings.payment_success');
        } else if (bookingPending && query.payment !== 'pending') {
          this.errors = { payment_error: [this.$t('lang.bookings.payment_error')] };
        }
      }
      if (query.cancel && query.cancel === 'success') {
        this.success_message = this.$t('lang.bookings.booking_cancelled');
      }
      if (query.review && query.review === 'success') {
        this.success_message = this.$t('lang.reviews.review_success');
      }
      if (query.add_discount && query.add_discount === 'success') {
        this.success_message = this.$t('lang.bookings.add_discount_success');
      }
      // if (query.update_schedules && query.update_schedules === 'success') {
      //   this.success_message = this.$t('lang.bookings.update_schedules_success');
      // }
    },

    bookingStatus() {
      // let statusClass = "none";
      const status = this.booking.booking_status;

      switch (status) {
        case 'pending':
          this.showReviews = true;
          break;
        case 'confirmed':
          this.showChat = true;
          this.showClaim = true;
          break;
        case 'at_store':
          this.showChat = true;
          this.showClaim = true;
          break;
        case 'closed':
          this.showChat = true;
          this.showClaim = true;
          this.showReviews = true;
          break;
        case 'cancelled':
          this.showReviews = true;
          break;
        default:
          break;
      }
      if (this.booking.claim) {
        this.showClaim = false;
      }
    },

    async cancelBooking() {
      this.success_message = null;
      this.errors = {};

      try {
        await BookingAPI.cancelBooking({
          booking_id: this.booking.id,
        });

        // GTAG Event
        dataLayer.push({
          event: 'cancel_booking',
          booking_id: this.booking.id,
          user_id: this.booking.user_id,
          value: this.booking.total_price,
          currency: this.booking.currency,
          bags_number: this.booking.bags_number,
        });

        // Reload page forced
        window.location.href = `${this.$router.currentRoute.path}?cancel=success`;
      } catch (error) {
        this.errors = errorResponse(error);
      }
      window.scrollTo(0, 0);
    },

    toHelpCenter() {
      window.location.href = `/${this.$store.state.main.lang}/full-help/`;
    },

    formatDateForUpdate(inputDate) {
      const date = new Date(inputDate);
      return `${date.getFullYear()}-${
        (`00${date.getMonth() + 1}`).slice(-2)}-${
        (`00${date.getDate()}`).slice(-2)} ${
        (`00${date.getHours()}`).slice(-2)}:${
        (`00${date.getMinutes()}`).slice(-2)}:${
        (`00${date.getSeconds()}`).slice(-2)}`;
    },

    updateBookingDiscount() {
      this.updateBookingData.discount_code = this.discountCode;
      this.updateBooking('add_discount');
    },

    updateBookingSchedules(updatedData) {
      if (updatedData.startDate) {
        this.updateBookingData.start_date = this.formatDateForUpdate(updatedData.startDate);
      }
      if (updatedData.endDate) {
        this.updateBookingData.end_date = this.formatDateForUpdate(updatedData.endDate);
      }
      if (updatedData.currency) {
        this.updateBookingData.currency = updatedData.currency;
      }
      if (updatedData.bagsNumber) {
        this.updateBookingData.bags_number = updatedData.bagsNumber;
      }
      if (updatedData.lockers) {
        if (!this.lockersInitialized) {
          // inicializa el valor de los lockers de la reserva
          // y evita el update booking la primera vez que se crean los componentes
          // para luego poder actualizar reserva normalmente
          this.updateBookingData.lockers = updatedData.lockers;
          this.lockers = updatedData.lockers;
          this.lockersInitialized = true;

          return;
        }
        this.updateBookingData.lockers = updatedData.lockers;
        this.lockers = updatedData.lockers;
      }

      this.updateBooking('update_schedules');
    },

    async updateBooking(origin) {
      this.success_message = null;
      try {
        // add tracking ids for payment return url
        const payload = this.updateBookingData;
        payload.data = getTrackingIds();

        const { data } = await BookingAPI.updateBooking(payload);

        this.$router.push(`/bookings/${data.id}?${origin}=success`);
        this.$router.go();
      } catch (error) {
        let errorMsg = {};
        errorMsg = errorResponse(error);
        if (error.response) {
          if (error.response.status === 401) {
            await this.$store.dispatch('setAuthToShow', 'login');
            this.$root.$emit('bv::show::modal', 'authModal');
            // GTAG Event
            dataLayer.push({
              event: 'open_auth_modal',
              source: 'booking',
            });
          }

          const reasonClosed = error.response.data.errors.update_booking_schedule_error;
          if (reasonClosed) {
            const errorObj = {};
            reasonClosed.forEach((reason) => {
              errorObj[reason] = [this.$t(`lang.stores.reason_closed.${reason}`)];
            });
            errorMsg = errorObj;
          }
        }
        this.resetUpdateBookingData();
        window.scrollTo(0, 0);

        this.modalAlertInfo = {};
        this.modalAlertInfo.list = errorMsg;
        this.modalAlertInfo.title = this.$t('lang.bookings.update_booking_error');
        this.modalAlertInfo.img = 'oh-no';
        this.$bvModal.show('alert-modal');
      }
    },

    resetUpdateBookingData() {
      this.updateBookingData = {
        booking_id: this.booking.id,
        start_date: this.booking.start_date,
        end_date: this.booking.end_date,
        bags_number: this.booking.bags_number,
        currency: this.booking.currency,
      };

      if (this.lockers) {
        this.updateBookingData.lockers = this.lockers;
      }
      if (this.booking.discount_code) {
        this.updateBookingData.discount_code = this.booking.discount_code;
      }
    },

    showAlerts() {
      let title = '';
      let text = '';
      let buttons = '';
      let img = '';

      if (this.$route.query.payment === 'pending') {
        title = this.$t('lang.bookings.payment_pending_title');
        text = this.$t('lang.bookings.payment_pending');
        img = 'payment_pending';
      } else if (this.booking.currency === 'ARS' && this.booking.user.country !== 'AR') {
        if (this.$route.query.payment === 'error') {
          title = this.$t('lang.bookings.payment_error_title');
        } else if (this.booking.store.available_currencies.length > 1) {
          title = this.$t('lang.bookings.currency_alert_title');
        } else {
          // no hay otra currency disponible - no muestro alerta
          title = '';
        }
        img = 'currency';

        text = this.$t('lang.bookings.option_currency_alert');
        buttons = [
          {
            title: this.$t('lang.bookings.alert_buttons.pay_ars'),
            click: 'closeModal',
            class: 'btn btn-light',
          },
          {
            title: this.$t('lang.bookings.alert_buttons.pay_usd'),
            click: 'changeCurrency',
            class: 'btn btn-dark',
          },
        ];
      }

      if (this.booking.lockers_changed) {
        title = this.$t('lang.lockers.availability_change_title');
        img = 'checklist';
        text = this.$t('lang.lockers.availability_change_text');
        buttons = '';
      }

      if (title) {
        this.modalAlertInfo = {};
        this.modalAlertInfo.title = title;
        this.modalAlertInfo.text = text;
        this.modalAlertInfo.buttons = buttons;
        this.modalAlertInfo.img = img;
        this.$bvModal.show('alert-modal');
      }
    },

    clickModal(action) {
      switch (action) {
        case 'changeCurrency':
          this.$store.dispatch('setCurrency', 'USD');
          this.updateBookingSchedules({ currency: 'USD' });
          break;
        case 'cancelBooking':
          this.cancelBooking();
          break;
        case 'closeModal':
        default:
          break;
      }

      this.$bvModal.hide('alert-modal');
    },

    checkInsuranceData() {
      if (this.booking.ask_for_insurance_data
          && (this.booking.booking_status === 'confirmed' || this.booking.booking_status === 'at_store')) {
        this.storeCountry = this.booking.store.country;
        this.bookingId = this.booking.id;
        this.userData = this.booking.user;
        this.$bvModal.show('insurance-data-modal');

        this.askForInsuranceData = true;
      } else {
        // si no abre el insurance modal, ver si hay que abrir el free tour.
        // si abre el insurance modal, cuando se cierra se llama al free tour.
        this.askForFreeTourData();
      }
    },

    getCivitatisData() {
      if (this.booking.store.city_id) {
        const city = cities.find((data) => data.bd_city_id === this.booking.store.city_id);
        if (city.civitatis_id) {
          this.showTransfer = true;
          this.cityId = city.id;
          this.transferUrl = `/transfer/${city.id}?store_id=${this.booking.store.id}`;
        }
      }
    },

    openTransfer() {
      ShippingAPI.shippingServiceRequest({
        booking_id: this.booking.id,
        booking_status: this.booking.booking_status,
        shipping_service_option: 'open-transfer-int',
      });
      this.$router.push(this.transferUrl);
    },

    showCancelBookingModal() {
      this.modalAlertInfo = {};
      this.modalAlertInfo.title = this.$t('lang.bookings.cancel_booking');

      if (this.booking.booking_status === 'confirmed') {
        this.modalAlertInfo.text = this.$t('lang.bookings.cancel_booking_text');
      }
      this.modalAlertInfo.img = 'umm';
      this.modalAlertInfo.buttons = [
        {
          title: this.$t('lang.bookings.no_cancel'),
          click: 'closeModal',
          class: 'btn btn-outline-dark',
        },
        {
          title: this.$t('lang.bookings.yes_cancel'),
          click: 'cancelBooking',
          class: 'btn btn-dark',
        },
      ];
      this.$bvModal.show('alert-modal');
    },
    showCannotCancelModal() {
      this.modalAlertInfo = {};
      this.modalAlertInfo.title = this.$t('lang.bookings.cannot_cancel_booking_title');
      this.modalAlertInfo.text = this.$t('lang.bookings.cannot_cancel_booking_text');
      this.modalAlertInfo.img = 'umm';
      this.$bvModal.show('alert-modal');
    },

    async askForFreeTourData() {
      this.selectedFreeTour = this.$store.state.search.additionalFreeTour;
      if (this.selectedFreeTour && this.booking.booking_status !== 'pending') {
        const { data } = await ActivitiesAPI.getActivityDetails(this.selectedFreeTour.id);
        if (data) {
          this.selectedFreeTourDetails = data;

          // awaits for DOM to load
          this.$nextTick(() => {
            this.$bvModal.show('selected-activity-modal');
            this.$store.dispatch('setAdditionalFreeTour', null);
          });
        }
      }
    },

  },
};
</script>
